import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Image from 'components/Image';
import Slim from 'components/vendor/Slim';

import cxHelpers from 'util/className';
import { toI18n } from 'util/i18n';

// Please reflect any changes made to the accepted
// filetypes here in company_profile_form.rb
const COMPANY_PROFILE_IMAGE_FILETYPES = 'image/gif, image/jpeg, image/png';

@cxHelpers('EditableImage')
class EditableImage extends PureComponent {
  static propTypes = {
    isEditing: PropTypes.bool.isRequired,
    src: PropTypes.string,
    fieldName: PropTypes.string,
    ratio: PropTypes.string.isRequired,
    parentCxElClass: PropTypes.string.isRequired,
    onUpdatePhoto: PropTypes.func,
    onFormUpdate: PropTypes.func,
    productLocation: PropTypes.string,
    useImageComponent: PropTypes.bool,
  };

  handleSave = newImage => {
    if (this.props.onFormUpdate) {
      this.props.onFormUpdate(this.removeCacheBust(newImage.output.image));
    } else {
      this.props.onUpdatePhoto(this.props.fieldName, {
        value: this.removeCacheBust(newImage.output.image),
      });
    }
  };

  handleRemove = () => {
    if (this.props.onFormUpdate) {
      this.props.onFormUpdate(null);
    } else {
      this.props.onUpdatePhoto(this.props.fieldName, { value: null });
    }
  };

  addCacheBust = () => {
    // only add cache-bust for assets that are referred to via their *path* and do not have an AWS
    // Date applied to their query parameters (these will already be cache busted)
    const src = this.props.src;
    return src && src.includes('http') && !src.includes('X-Amz-Date')
      ? `${src}?cb=${new Date().getTime()}`
      : src;
  };

  removeCacheBust = image =>
    image.includes('http') ? image.split('?')[0] : image;

  handleImageRendering = (src, parentCxElClass) => {
    const { useImageComponent } = this.props;
    if (useImageComponent) {
      if (src) {
        return (
          <Image
            className={parentCxElClass}
            src={src}
            expandedSrc={src}
            expandable
          />
        );
      }
      return toI18n('uploader.no_image');
    }

    return (
      <div
        className={parentCxElClass}
        style={{ backgroundImage: `url(${src})` }}
      />
    );
  };

  render() {
    const { src, ratio, isEditing, fieldName, parentCxElClass } = this.props;

    return (
      <div>
        {isEditing ? (
          <Slim
            label={toI18n('hiring.company_profile.editable_image_label')}
            initialImage={this.addCacheBust()}
            ratio={ratio}
            didSave={this.handleSave}
            didRemove={this.handleRemove}
          >
            <input
              id="file_upload"
              type="file"
              name={fieldName}
              accept={COMPANY_PROFILE_IMAGE_FILETYPES}
            />
          </Slim>
        ) : (
          this.handleImageRendering(src, parentCxElClass)
        )}
      </div>
    );
  }
}

export default EditableImage;
